import { Trans } from '@lingui/macro'
import { Percent } from '@uniswap/sdk-core'
import { headline } from 'nft/css/common.css'
import styled from 'styled-components/macro'
import { gradients } from 'theme/colors'
import { gradientBorder } from 'theme/styles'

import { ColumnCenter } from '../Column'
import { RowBetween, RowFixed } from '../Row'
import SettingsTab from '../Settings'

const StyledSwapHeader = styled.div`
  position: relative;
  padding: 16px;
  width: 100%;
  color: ${({ theme }) => theme.textSecondary};

  border-radius: 4px 4px 0 0;
  ${gradientBorder(gradients.gradientBorderTertiary, { sides: { bottom: false } })};

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    z-index: -1;
    border-radius: inherit;
    backdrop-filter: blur(8px);
    background: ${({ theme }) => theme.surfaceClearBackground};
  }
`

const TextSubHeader = styled.div`
  color: ${({ theme }) => theme.textSecondary};
  font-size: 14px;
  line-height: 18px;
  font-weight: 400;
`

const TextHeader = styled.div`
  color: ${({ theme }) => theme.white};
  font-size: 32px;
  line-height: 34px;
  font-weight: 500;
`

export default function SwapHeader({ allowedSlippage }: { allowedSlippage: Percent }) {
  return (
    <StyledSwapHeader>
      <RowBetween>
        <RowFixed style={{ width: '20px', visibility: 'hidden' }} />
        <ColumnCenter style={{ gap: '8px' }}>
          <TextHeader>
            <Trans>Swap</Trans>
          </TextHeader>
          <TextSubHeader className={headline}>
            <Trans>Search pairs or tokens</Trans>
          </TextSubHeader>
        </ColumnCenter>
        <RowFixed>
          <SettingsTab placeholderSlippage={allowedSlippage} />
        </RowFixed>
      </RowBetween>
    </StyledSwapHeader>
  )
}
